import React from "react";
import { Box } from "grommet";

const StatusDot = ({ status }) => {
  const color = status === 1 ? "status-ok" : "status-critical";
  const title = status === 1 ? "Published" : "Unpublished";
  return (
    <Box
      width="10px"
      height="10px"
      round="full"
      background={color}
      title={title}
      margin={{ right: "small" }}
    />
  );
};

export default StatusDot;
